module.exports = __webpack_public_path__ + "assets/putao.acdf14ae.svg";